'use strict';

var animations = function () {
  var AOS = require('aos');
  AOS.init({
    easing: 'ease-out-cubic',
    duration: 700,
    delay: 50,
    offset: 100
  });
}

module.exports = animations;
